export default [
  {
    name: 'project_contribute_button',
    component_path: 'modules/templates/blocks/project/ProjectContributeButton'
  }
]